module.exports = ".icon-container{\r\n\twidth: 100px;\r\n}\r\n\r\n.icon-container mat-icon{\r\n\tpadding-top: 10%;\r\n\tfont-size: 5em;\r\n}\r\n\r\n.message-container{\r\n\tmax-width: 400px;\r\n}\r\n\r\n.message-container p{\r\n\tword-wrap: break-word\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/error-dialog/error-dialog.component.css
// module id = ./src/app/shared/components/error-dialog/error-dialog.component.css
// module chunks = main